import { Link } from "react-router-dom";
import type { Article } from "@/mocks/articles";

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <Link
      to={`/article/${article.id}`}
      className="group flex flex-col sm:flex-row gap-4 p-4 rounded-xl bg-white border border-neutral-100 hover:border-primary-200 transition-all duration-300"
    >
      <div className="w-full sm:w-48 h-32 flex-shrink-0 rounded-lg overflow-hidden">
        <img
          src={article.cover}
          alt={article.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex flex-col justify-between flex-1 min-w-0">
        <div>
          <h3 className="text-sm font-semibold text-foreground-900 line-clamp-2 group-hover:text-primary-600 transition-colors">
            {article.title}
          </h3>
          <p className="text-xs text-foreground-500 mt-2 line-clamp-2">
            {article.excerpt}
          </p>
        </div>
        <div className="flex items-center gap-3 mt-3">
          <span className="text-xs text-foreground-400">{article.source}</span>
          <span className="text-xs text-foreground-300">·</span>
          <span className="text-xs text-foreground-400">{article.publishedAt}</span>
          {article.tags.slice(0, 2).map((tag) => (
            <span key={tag} className="px-2 py-0.5 bg-secondary-100 text-secondary-700 text-xs rounded-full whitespace-nowrap">
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}